export default __webpack_public_path__ + "images/referenzen/produktfilm/hatraco_rosenthal_tuetenvasen.mp4";